<template>
    <v-dialog
        v-model="value"
        persistent
        max-width="518px"
        max-height="658px"
        content-class="bible-form-dialog"
    >
        <replace-form
            :data-gathering="dataGathering"
            @replace="this.confirm"
            @cancel="this.close"
        />
    </v-dialog>
</template>

<script>
import DialogMixin from "@/Shared/Dialogs/DialogMixin";
import ReplaceForm from "@/Shared/DathaGatherings/Common/Forms/ReplaceForm";

export default {
    name: "ReplaceFormDialog",

    components: {ReplaceForm},

    mixins: [DialogMixin],

    props: {
        dataGathering: {
            type: Object,
            require: true,
        },
    },

    data: () => ({

    }),

    methods: {

    },
}
</script>

<style scoped>

</style>
